export enum JagaAddressType {
  Company = 'COMPANY',
  Customer = 'CUSTOMER',
  Store = 'STORE',
  Other = 'OTHER',
}
